import React from "react";
import moment from "moment";
import { Link } from "react-router";
import { Table, Tr, Td, Sort } from "reactable";
import { RaisedButton } from "material-ui";

import InlineLinkIconButton from "./inline-link-icon-button.jsx";
import * as util from "../../util";

class EventSalesAnalyticsTable extends React.Component {
  constructor(props) {
    super(props);
    this._makeRow = this._makeRow.bind(this);
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object
    };
  }

  _makeRow(eventBucket, id, data, options = {}) {
    let noWrapTdStyle = { whiteSpace: "nowrap" };

    return (
      <Tr key={id}>
        {options.event ? (
          <Td column="Event" value={options.event.name}>
            <span>
              {options.event.name}
              {options.event.id && (
                <InlineLinkIconButton
                  onTouchTap={() => {
                    this.context.router.push(
                      `/event_buckets/${eventBucket}/events/${options.event.id}`
                    );
                  }}
                  tooltip="View event"
                />
              )}
            </span>
          </Td>
        ) : options.venue ? (
          <Td column="Venue" value={options.venue.name}>
            <span>
              {options.venue.name}
              {options.venue.id && (
                <InlineLinkIconButton
                  onTouchTap={() => {
                    this.context.router.push(
                      `/event_buckets/${eventBucket}/venues/${options.venue.id}`
                    );
                  }}
                  tooltip="View venue"
                />
              )}
            </span>
          </Td>
        ) : options.tag ? (
          <Td column="Tag" value={options.tag.name}>
            <span>
              {options.tag.name}
              {options.tag.id && (
                <InlineLinkIconButton
                  onTouchTap={() => {
                    this.context.router.push(
                      `/event_buckets/${eventBucket}/tags/${options.tag.id}`
                    );
                  }}
                  tooltip="View tag"
                />
              )}
            </span>
          </Td>
        ) : null}
        <Td column="Web" value={data.web} style={noWrapTdStyle}>
          {util.formatPrice(data.web)}
        </Td>
        <Td column="Box office" value={data.box_office} style={noWrapTdStyle}>
          {util.formatPrice(data.box_office)}
        </Td>
        <Td column="Rush line" value={data.rush_line} style={noWrapTdStyle}>
          {util.formatPrice(data.rush_line)}
        </Td>
        <Td column="Total" value={data.total} style={noWrapTdStyle}>
          {util.formatPrice(data.total)}
        </Td>
      </Tr>
    );
  }

  downloadCsv(data, events) {
    util.clientSideDownload(
      `event-sales-analytics-${util.snakeCase(
        this.props.eventBucket.name
      )}.csv`,
      "text/csv",
      util.makeCsv(
        [
          ["Event", "Venue", "Date", "Web", "Box office", "Rush line", "Total"]
        ].concat(
          Object.keys(data).map(id => {
            let event = events[id] || { name: "Deleted event" };
            return [
              event.name,
              event.venue && event.venue.name,
              event.start_time && moment(event.start_time).format("llll"),
              data[id].web / 100 || 0,
              data[id].box_office / 100 || 0,
              data[id].rush_line / 100 || 0,
              data[id].total / 100 || 0
            ];
          })
        )
      )
    );
  }

  render() {
    let { data, eventBucket, groupBy, events, venues, tags } = this.props,
      rows;

    if (groupBy === "venue") {
      const byVenue = {};
      Object.keys(data).map(id => {
        const event = events[id] || { venue: { id: "undefined" } };
        if (!byVenue[event.venue.id]) {
          byVenue[event.venue.id] = {};
        }
        Object.keys(data[id]).forEach(k => {
          byVenue[event.venue.id][k] =
            (byVenue[event.venue.id][k] || 0) + data[id][k];
        });
      });
      rows = Object.keys(byVenue).map(id => {
        return this._makeRow(eventBucket.id, id, byVenue[id], {
          venue: venues[id] || { name: "No venue" }
        });
      });
    } else if (groupBy === "tag") {
      const byTag = {};

      Object.keys(data).map(id => {
        const event = events[id] || { tags: [] };
        (event.tags.length ? event.tags : [{}]).forEach(tag => {
          if (!byTag[tag.id]) {
            byTag[tag.id] = {};
          }
          Object.keys(data[id]).forEach(k => {
            byTag[tag.id][k] = (byTag[tag.id][k] || 0) + data[id][k];
          });
        });
      });
      rows = Object.keys(byTag).map(id => {
        return this._makeRow(eventBucket.id, id, byTag[id], {
          tag: tags[id] || { name: "No tag" }
        });
      });
    } else {
      rows = Object.keys(data).map(id => {
        return this._makeRow(eventBucket.id, id, data[id], {
          event: events[id] || { name: "Deleted event" }
        });
      });
    }

    const primaryColumn =
      groupBy === "venue" ? "Venue" : groupBy === "tag" ? "Tag" : "Event";

    return (
      <div>
        <Table
          className="bordered striped responsive-table"
          sortable={[primaryColumn, "Web", "Box office", "Rush line", "Total"]}
          defaultSort={{ column: "Total", direction: "desc" }}
          columns={[primaryColumn, "Web", "Box office", "Rush line", "Total"]}
        >
          {rows}
        </Table>
        {groupBy === "event" ? (
          <RaisedButton
            style={{ marginTop: "1em" }}
            label="Download (.csv)"
            onTouchTap={() => this.downloadCsv(data, events)}
          />
        ) : null}
      </div>
    );
  }
}

EventSalesAnalyticsTable.defaultProps = {
  groupBy: "event"
};

export default EventSalesAnalyticsTable;



// WEBPACK FOOTER //
// ./src/app/components/partials/event-sales-analytics-table.jsx